export function useValidation() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
    const phoneRegex = /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;

    /**
     * Validates an email address
     * @param {string} email - The email address to validate
     * @returns {boolean} True if valid, false otherwise
     */
    const isValidEmail = (email) => {
        if (!email || typeof email !== 'string') {
            return false;
        }

        return emailRegex.test(email.trim().toLowerCase());
    };

    /**
     * Validates a phone number
     * @param {string} phone - The phone number to validate
     * @returns {boolean} True if valid, false otherwise
     */
    const isValidPhone = (phone) => {
        if (!phone || typeof phone !== 'string') {
            return false;
        }

        return phoneRegex.test(phone.trim());
    };

    return {
        isValidEmail,
        isValidPhone
    };
}